// ENERGY v2 — list a wallet with the desk, as a sheet (?add=1) (UI rebuild batch 4, adopted by the energy lane).
// ONE COPY: the state and its checks are screens/Energy.tsx's useAddWallet — one of the Books' register, PICKED, never typed
// (operator, 4 Oct 2026, D6); the register's own name, nobody types a label (N-091); the whole address of what was picked shown
// to be read before it is added (WillList); the same three refusals in words; api.energyAddWallet. Only the frame is new: a sheet
// with Astra's one primary in its footer, where Energy.tsx unfolds a box above the wallets.
import type { EnergyStatus } from '../../../lib/api';
import { errorWords } from '../../../lib/errors';
import { DetailSheet, StateLine } from '../kit';
import { Field } from '../../Field';
import { AllListed, Said, WillList, mask, useAddWallet } from '../../../screens/Energy';

export function AddWalletSheet({ d, onClose }: { d: EnergyStatus; onClose: () => void }) {
  const f = useAddWallet({ d, onDone: onClose });
  const { candidates, picked, pick, standing, setStanding, problem, add, chosen } = f;

  // An unreadable register: the list says so once, and its link is off. Nothing to add from here.
  if (candidates === null) {
    return (
      <DetailSheet title="Add a wallet" onClose={onClose}>
        <StateLine tone="warn" more="The Books' wallet register could not be read just now. Until it can be, no wallet is added, topped up or given a standing figure from here.">
          Books&apos; register unreadable — nothing can be added.
        </StateLine>
      </DetailSheet>
    );
  }
  if (candidates.length === 0) {
    return (
      <DetailSheet title="Add a wallet" onClose={onClose}>
        <AllListed />
      </DetailSheet>
    );
  }

  return (
    <DetailSheet title="Add a wallet" onClose={onClose}
      footer={
        <div className="flex lg:justify-end">
          <button type="button" className="btn-primary w-full disabled:opacity-50 lg:w-auto lg:px-6" disabled={add.isPending} onClick={f.submit}>
            {add.isPending ? 'Adding…' : 'Add'}
          </button>
        </div>
      }>
      <div className="space-y-4">
        <Field label="Wallet">
          <select className="select" value={picked} onChange={(e) => pick(e.target.value)}>
            <option value="">Choose a wallet</option>
            {candidates.map((c) => (
              <option key={c.booksWalletId} value={String(c.booksWalletId)}>{c.name} — {mask(c.address)}</option>
            ))}
          </select>
        </Field>
        <Field label="Standing energy" hint="optional">
          <input className="input font-mono" inputMode="numeric" value={standing} onChange={(e) => setStanding(e.target.value)} />
        </Field>
        {/* The whole address of what was picked — the one the desk will list — to be read before it is added. */}
        {chosen && <WillList d={d} address={chosen.address} />}
        {/* words:ok — the desk's or the Books' own refusal, first clause on the line (Said) */}
        {problem !== null ? <Said text={problem} /> : add.isError ? <Said text={errorWords(add.error)} /> : null}
      </div>
    </DetailSheet>
  );
}
